import type { BarSpan } from "./DensityChart.lib";
import type { BarLimits, WindowPart } from "./windowSpan.lib";
import {
    dragSpan,
    edgeOf,
    isSameSpan,
    resizeSpan,
    snapSpan,
} from "./windowSpan.lib";

const KEY_STEPS: Partial<Record<string, number>> = {
    ArrowLeft: -1,
    ArrowRight: 1,
};

interface KeySpanParams extends BarLimits {
    span: BarSpan;
    mode: WindowPart;
    key: string;
}

/**
 * The body moves a bar and snaps; an edge steps to the next whole bar in the
 * key's direction and the other edge stays put. Null when nothing changes.
 */
export function keySpan({
    span,
    mode,
    key,
    barCount,
    minBar = 0,
}: KeySpanParams): BarSpan | null {
    const step = KEY_STEPS[key];
    if (step === undefined) {
        return null;
    }
    const moved = dragSpan({
        span,
        mode: "move",
        deltaBars: step,
        barCount,
        minBar,
    });
    if (mode === "move" && moved.start === span.start) {
        return null;
    }
    const next =
        mode === "move"
            ? snapSpan({
                  span: moved,
                  from: span,
                  mode,
                  barCount,
                  minBar,
              })
            : resizeSpan({
                  span,
                  edge: mode,
                  position:
                      step > 0
                          ? Math.floor(edgeOf(span, mode)) + 1
                          : Math.ceil(edgeOf(span, mode)) - 1,
                  barCount,
                  minBar,
              });
    return isSameSpan(next, span) ? null : next;
}
